import Crud from '../components/VehicleTypes/Crud'
import Entity from '../components/VehicleTypes/Add'

let routes = {
    path: '/vehicleTypes',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/vehicleTypes/add',
            name: 'Novo Tipo de Veículo',
            component: Entity
        },   
        {
            path: '/vehicleTypes/edit/:id?',
            name: 'Editar Tipo de Veículo',
            component: Entity
        },
        {
            path: '/vehicleTypes',
            name: 'Tipos de Veículos',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/vehicleType.js